<template>
  <div class="c-modal third-login-dom" v-if="pageVisible">
    <div class="mask">
      <div v-if="isRecoveraccount" class="steps">
        <div class="steps-row">
          <div class="step active">
            <span class="step-number">1</span>
            <span class="step-label">登录老账号</span>
          </div>
          <div class="step">
            <span class="step-number">2</span>
            <span class="step-label">绑定新账号</span>
          </div>
          <div class="step">
            <span class="step-number">3</span>
            <span class="step-label">账号迁移成功</span>
          </div>
        </div>
        <div class="tip-text">
          <div>原mureka.ai老账号需迁移至mureka.cn</div>
          <div>请登录老账号</div>
        </div>
      </div>

      <div class="content">
        <div class="mobile-title">
          <div class="left">Sign in Mureka</div>
          <img
            v-if="!isRecoveraccount"
            @click="closePage"
            src="@/assets/icons/closeBtn.svg"
            alt=""
          />
        </div>
        <div v-if="!isRecoveraccount" class="close-btn" @click="closePage">
          <img src="@/assets/icons/closeBtn.svg" alt="" />
        </div>
        <div class="bg-img">
          <div class="login-module-main login-in-main">
            <div class="login-img-box">Sign in Mureka</div>
            <div class="login-in-main-content">
              <GoogleThirdLogin @continueWith="continueWith" />
            </div>
            <div class="third-login-box">
              <img
                @click="facebookLogin"
                src="@/assets/img/login/ic-facebook.png"
                alt=""
              />
              <img
                @click="discordLogin"
                src="@/assets/img/login/ic-discord.png"
                alt=""
              />
              <img
                @click="signInAppleLogin"
                src="@/assets/img/login/ic-apple.png"
                alt=""
              />
            </div>
            <div class="terms">
              By continuing, you agree to
              <a
                href="/service_terms.pdf"
                target="_blank"
                class="a-link btn pointer"
              >
                Terms of Use</a
              >
              and
              <a
                href="/privacy_policy.pdf"
                target="_blank"
                class="a-link btn pointer"
              >
                Privacy Policy</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import message from "@/components/functionCallComponent/message/message.js";
import apiUser from "@/api/api/apiUser.js";
import useUserDataStore from "@/store/userDataStore";
import { funComponentList } from "@/components/functionComp/index";
import { getParameterByName } from "@/utils/tools.js";
import GoogleThirdLogin from "@/components/login/GoogleThirdLogin.vue";
import Rights from "./rights.vue";
import { firebaseUtils } from "@/utils/analytic/firebaseUtils.js";
import globleConfig from "@/config/config.js";
import { $$language, $$t } from "@/i18n/i18n.js";

const isRecoveraccount = window.location.pathname.includes("/recoveraccount");

//自定义函数组件无法使用全局组件，需要单独引入
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  okText: {
    type: String,
    default: "确定",
  },
  handleOk: {
    type: Function, //成功回调
    default: null,
  },
  handleCancel: {
    type: Function, //失败回调
    default: null,
  },
  remove: {
    type: Function, //传入移除节点方法,这里是createApp中的方法
    default: null,
  },
  content: {
    type: String,
    default: "自定义全局函数组件......",
  },
  rightType: {
    type: String, // 'generate' | 'login' | undefined, // 显示权益的类型
    default: "login",
  },
  create_type: {
    type: String,
    default: "2",
  },
  source: {
    type: String,
    default: "other",
  },
  signup_source: {
    type: String,
    default: "",
  },
});

const pageVisible = ref(false);
pageVisible.value = props.visible;
// 监听显示的消失，需要移除dom
watch(
  () => pageVisible.value,
  (val) => {
    !val && props.remove();
  }
);

const userDataStore = useUserDataStore();

const closePage = () => {
  pageVisible.value = false;
  localStorage.removeItem(`${globleConfig.appname}_create_data`);
  firebaseUtils.logClickEvent(
    props.rightType === "generate" ? "close_new_user_login" : "close_login",
    {
      create_type: props.create_type,
      page_route: window.location.pathname,
      source: props.source,
    }
  );
};

const goLogin = () => {
  pageVisible.value = false;
  funComponentList.LogIn({
    // content: "在request.ts触发的函数式组件",
    handleOk: props.handleOk,
    handleCancel: props.handleCancel,
    rightType: props.rightType,
    create_type: props.create_type,
    source: props.source,
  });
};

const goSignUp = () => {
  message.error({
    maskClosable: true,
    position: "top",
    content:
      "Email registration not supported temporarily,Please continue with Google.",
  });
  // pageVisible.value = false
  // funComponentList.SignUp({
  //   // content: "在request.ts触发的函数式组件",
  //   handleOk: props.handleOk,
  //   handleCancel: props.handleCancel,
  //   rightType: props.rightType,
  // })
};

const discordLogin = () => {
  if (props.signup_source) {
    sessionStorage.setItem("signup_source", props.signup_source);
  }
  const clientId = "1271026704529362995"; // 从 Discord 应用获取
  const url =
    window.location.pathname == "/recoveraccount"
      ? `${window.location.origin}/recoveraccount`
      : window.location.pathname == "/create"
      ? `${window.location.origin}/create`
      : `${window.location.origin}/`;
  const redirectUri = encodeURIComponent(url);
  const discordAuthUrl = `https://discord.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=identify`;

  // 重定向到 Discord 授权页面
  window.location.href = discordAuthUrl;
};

const continueWith = async (state) => {
  // firebaseUtils.testViewEvent()

  firebaseUtils.logClickEvent(
    props.rightType === "generate" ? "newuser_login" : "login",
    {
      create_type: props.create_type,
      source: props.source,
      page_route: window.location.pathname,
    }
  );
  userDataStore
    .threeLogin(state.x_auth_token, false, props.signup_source)
    .then(() => {
      typeof props.handleOk === "function" && props.handleOk(true);
      pageVisible.value = false;
    });
};

const facebookLogin = () => {
  FB.login(
    function (respond) {
      if (respond?.authResponse) {
        console.log("facebookLogin🔥=>", respond?.authResponse);
        userDataStore
          .threeLogin(
            respond?.authResponse?.accessToken,
            false,
            props.signup_source,
            "facebook_web"
          )
          .then(() => {
            facebookLoginOut();
            typeof props.handleOk === "function" && props.handleOk(true);
            pageVisible.value = false;
          });
      }
    },
    { scope: "public_profile,email" }
  );
};

const facebookLoginOut = () => {
  FB.getLoginStatus(function (response) {
    if (response.status === "connected") {
      FB.logout(function (response) {
        console.log("Facebook 退出成功", response);
      });
    } else {
      console.log("用户未登录 Facebook");
    }
  });
};

const initAppleLogin = () => {
  console.log("AppleID", AppleID.auth);
  if (AppleID?.auth) {
    const nonce = Math.random().toString(36).substr(2, 10);
    const currentPath = window.location.pathname;
    let apiUrl = `${window.location.origin}/api/notify/ios`;
    if (currentPath === "/recoveraccount") {
      apiUrl += "?page=recoveraccount";
    }
    AppleID.auth.init({
      clientId: "ai.mureka.service",
      redirectURI: apiUrl,
    });
  }
};

const signInAppleLogin = () => {
  try {
    if (props.signup_source) {
      sessionStorage.setItem("signup_source", props.signup_source);
    }
    AppleID.auth.signIn();
  } catch (error) {
    console.error(" Apple Sign In Error: ", error);
  }
};

onMounted(() => {
  // console.log("orios.", props.create_type);
  // if (props.rightType === "login") {
  //   firebaseUtils.logViewEvent("login", {
  //     create_type: props.create_type,
  //     page_route: window.location.pathname,
  //     source: props.source,
  //   });
  // }

  initAppleLogin();
});

defineExpose({ remove: props.remove });
</script>

<style lang="scss" scoped>
.c-modal {
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2025;
  .mask {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 48px;
    .steps {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .tip-text {
        text-align: center;
        font-size: 16px;
        font-weight: normal;
      }

      .steps-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 100px;
        margin-bottom: 40px;
      }

      .step {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;

        .step-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          font-weight: bold;
          font-size: 20px;
          background: #fff;
          color: #220c35;
        }

        &.active .step-number {
          background: #94adff;
          color: #000;
        }

        &.completed {
          .step-label {
            color: #94adff;
          }
          .step-number {
            background: #94adff;
            color: #fff;
            position: relative;
            font-size: 0; // 隐藏数字
            &::after {
              content: "";
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url("@/assets/img/login/icon-success.png") no-repeat
                center/contain;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }

        .step-label {
          color: #fff;
          font-size: 20px;
        }
      }
    }

    .content {
      position: relative;
      left: 0;
      top: 0;
      transform: none;
      background: #ffffff;
      overflow: hidden;
      border-radius: 20px;
      .third-login-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 60px;
        height: 80px;
        margin-bottom: 8px;
        img {
          width: 48px;
          height: 48px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .login-in-main {
        width: 100%;
        color: #000;
        .login-img-box {
          text-align: center;
          font-size: 22px;
          font-weight: bold;
          line-height: 56px;
          height: 56px;
          text-align: center;
          margin-bottom: 12px;
        }
      }
      .terms {
        color: #000;
        a {
          color: #0741ff;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .mask {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 24px;
      .close-btn {
        display: none;
      }
      .steps {
        .steps-row {
          gap: 16px;
          margin-bottom: 24px;
          flex-wrap: nowrap; // 保证不换行
        }
        .step .step-label {
          font-size: 13px;
          white-space: nowrap; // 防止 label 换行
        }
        .step .step-number {
          width: 20px;
          height: 20px;
          min-width: 20px;
          min-height: 20px;
          border-radius: 50%;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          &::after {
            width: 20px !important;
            height: 20px !important;
          }
        }
        .step {
          width: auto; // 不要100%，自适应内容
          text-align: left;
          gap: 8px;

          &.active {
            .step-number {
              color: #000 !important;
            }
          }
        }
      }
    }
    .content {
      box-sizing: content-box;
      margin: 0;
      padding: 20px;
      width: 300px;
    }
    .content {
      .terms {
        margin-bottom: 0;
      }
    }
  }
}

.sign-up-block {
  padding: 14px 16px;
  text-align: center;
  height: 52px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-bottom: 8px;
  cursor: pointer;

  font-size: 16px;
  font-weight: normal;
  line-height: 24px;

  &:hover {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>
